import Region from '../../../constants/region';
import Environment from '../../Environment';
import MockSplit from '../../MockSplit';
import stages from '../stages';

const prod = new Environment({
    name: stages.PRODUCTION,
    regions: [Region.MMPA],
});

const demo = new Environment({
    ...prod,
    name: stages.DEMO,
});

const staging = new Environment({
    ...prod,
    name: stages.STAGING,
});

const local = new Environment({
    ...prod,
    name: stages.LOCAL,
});

const dev = new Environment({
    ...prod,
    name: stages.DEV,
});

const use_two_level_banking_approval = new MockSplit({
    name: 'use_two_level_banking_approval',
    environments: [local, dev, staging, demo, prod],
});

export default use_two_level_banking_approval;
